<template>
    <div>测试ao授权页面</div>
</template>

<script>
import {aoAuth} from "@/js/designer";

export default {
    name: "index",
    created() {
        $init(()=>{
            aoAuth().then(ao=>{
                if(ao.data.result.is_auth==0){
                    window.location.href=ao.data.result.oauth_url
                }else{
                   Toast('艾欧圈授权成功')
                }
            })
        })
    }
}
</script>

<style scoped>

</style>
